import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../utils/propUtils';
import VeltRecorderControlPanelActionBarWireframe from '../VeltRecorderControlPanelActionBarWireframe/VeltRecorderControlPanelActionBarWireframe';
import VeltRecorderControlPanelVideoWireframe from '../VeltRecorderControlPanelVideoWireframe/VeltRecorderControlPanelVideoWireframe';
import VeltRecorderControlPanelLoadingWireframe from '../VeltRecorderControlPanelLoadingWireframe/VeltRecorderControlPanelLoadingWireframe';
var VeltRecorderControlPanelThreadModeWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recorder-control-panel-thread-mode-wireframe", __assign({}, transformedProps), children));
};
VeltRecorderControlPanelThreadModeWireframe.Video = VeltRecorderControlPanelVideoWireframe;
VeltRecorderControlPanelThreadModeWireframe.Loading = VeltRecorderControlPanelLoadingWireframe;
VeltRecorderControlPanelThreadModeWireframe.ActionBar = VeltRecorderControlPanelActionBarWireframe;
export default VeltRecorderControlPanelThreadModeWireframe;
